import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { Admin } from '../models/admin.model';
import {StorageService} from './storage.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  private apiUrl = `${environment.apiUrl}/users`;

  constructor(private http: HttpClient,  private storage: StorageService,) {}

  getCurrentAdmin(clientId: string): Observable<Admin> {
    let userId = this.storage.getItem('userId');

    if (!userId || userId === 'undefined') {
      console.error('ERREUR: No valid userId found');
      return throwError('User not authenticated');
    }
    const url = `${this.apiUrl}/${userId}?clientId=${encodeURIComponent(clientId)}`;
    return this.http.get<Admin>(url);
  }
}
